





















































































































import { Component, Vue } from "vue-property-decorator";
import publicApi from "@/network/public_api";
import { AxiosError, AxiosResponse } from "axios";
import { Locales } from "../../i18n/locales";

@Component
export default class ResetPasswordPage extends Vue {
  newPassword = "";
  newPasswordConfirm = "";
  disableInputs = false;
  isSubmitting = false;

  validate(): boolean {
    if (this.newPassword !== this.newPasswordConfirm) {
      (Vue as any).$toast.error(
        this.$t("Confirm password must match new password"),
        {
          position: this.$i18n.locale === Locales.EN ? "top-right" : "top-left",
        }
      );
      this.newPasswordConfirm = "";

      return false;
    }

    if (!/(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9]).{8,}/.test(this.newPassword)) {
      (Vue as any).$toast.error(this.$t("passwordComplexity"), {
        position: this.$i18n.locale === Locales.EN ? "top-right" : "top-left",
      });
      this.newPassword = "";
      this.newPasswordConfirm = "";
      return false;
    }

    return true;
  }

  resetPassword(): void {
    const token = this.$route.query.token;
    const email = this.$route.query.email;

    if (this.validate() && !this.isSubmitting) {
      this.isSubmitting = true; //? disables sending multiple requests.

      publicApi
        .post("reset_password", {
          token: token,
          email: email,
          password: this.newPassword,
        })
        .then((res: AxiosResponse) => {
          this.disableInputs = true;
          (Vue as any).$toast.success(res.data.message, {
            position:
              this.$i18n.locale === Locales.EN ? "top-right" : "top-left",
          });
        })
        .catch((err: AxiosError) => {
          (Vue as any).$toast.warning(err?.response?.data?.message, {
            position:
              this.$i18n.locale === Locales.EN ? "top-right" : "top-left",
          });
        })
        .finally(() => {
          this.isSubmitting = false;
        });
    }
  }
}
